import React from 'react';
import { inject, observer } from 'mobx-react';
import { Box } from '@mantine/core';
import { PatientJournalList } from '../../PatientDashboard/PatientJournal/PatientJournalList';

const PatientJournals: React.FC = inject()(
    observer(() => {
        return (
            <Box>
                <PatientJournalList isHcpView={true} />
            </Box>
        );
    }),
);

export default PatientJournals; 